module.exports = __webpack_public_path__ + "static/media/star-filled.d63a7d27.svg";